'use strict';

import GLightbox from 'glightbox'

const SELECTOR = 'js-inline-modal';

export function init() {
    const element = document.querySelector('.' + SELECTOR);

    if (element === null) {
        return false;
    }

    const lightbox = GLightbox({
        selector: SELECTOR,
        height: "auto",
        draggable: false,
        closeButton: false
    });

    document.addEventListener('click', function (event) {
        if (!event.target.matches('.js-inline-modal__close')) return;

        lightbox.close();
    }, false);
}
